export default {
    tooltip: 'Adjust calories: scale every quantity up or down',
    badge: 'Beta',
    title: 'Adjust calories',
    modes: {
        percent: 'Percentage',
        fixed: 'Fixed calories',
    },
    fixedLabel: 'Calories per day',
    averagePerDay: 'Average per day',
    emptyDay: 'No foods',
    unchanged: 'Unchanged',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    noFoods: 'This plan has no foods to adjust yet.',
    largeChange: 'Days in red change by more than 25%, so their meals may need a look.',
    hint: 'Calories are approximate, since quantities are rounded to keep the amounts natural. The change can be undone.',
    apply: 'Apply',
    done: 'Average per day: {before} → {after} kcal',
};
